import { useRef, useState } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { Link } from "react-router-dom";

export default function ContactForm() {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "", marketingConsent: false });
  const captchaRef = useRef(null);

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!captchaToken) {
      if (captchaRef.current) captchaRef.current.execute();
      return alert("Please complete the CAPTCHA.");
    }

    const res = await fetch("/api/contact.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        source: "contact_form",
        pageUrl: window.location.href,
        referrer: document.referrer || "",
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
        marketingConsent: form.marketingConsent,
        marketingConsentVersion: "email-marketing-v1-2026-07-27",
        hcaptchaToken: captchaToken,
      }),
    });

    const result = await res.json();

    if (result.success) {
      alert("Message sent!");
      setForm({ name: "", phone: "", email: "", message: "", marketingConsent: false });
      setCaptchaToken(null);
      if (captchaRef.current) captchaRef.current.resetCaptcha();
    } else {
      alert("Failed to send message: " + (result.error || "Unknown error"));
    }
  };

  const fieldClass = "w-full rounded-2xl border border-white/10 bg-slate-950/60 p-4 text-white placeholder:text-slate-400 outline-none transition focus:border-cyan-300 focus:ring-2 focus:ring-cyan-300/20";

  return (
    <section id="contact" className="px-6 py-20">
      <div className="mx-auto max-w-5xl rounded-[2rem] border border-white/10 bg-white/10 p-8 shadow-2xl shadow-black/20 backdrop-blur md:p-12">
        <p className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">
          Get in touch
        </p>
        <h2 className="mb-4 text-center text-3xl font-bold leading-tight text-white md:text-5xl">
          Start the planning conversation.
        </h2>
        <p className="mx-auto mb-10 max-w-2xl text-center text-slate-200">
          Tell us what you are trying to solve, and we will help clarify the next best step.
        </p>

        <form className="mx-auto max-w-2xl space-y-4" onSubmit={handleSubmit}>
          <input name="name" type="text" placeholder="Your Name" value={form.name} onChange={handleChange} required className={fieldClass} />
          <input name="phone" type="tel" placeholder="Your Phone Number" value={form.phone} onChange={handleChange} required className={fieldClass} />
          <input name="email" type="email" placeholder="Your Email" value={form.email} onChange={handleChange} required className={fieldClass} />
          <textarea name="message" rows="5" placeholder="Your Message" value={form.message} onChange={handleChange} required className={fieldClass} />
          <label className="flex items-start gap-3 rounded-2xl border border-white/10 bg-slate-950/40 p-4 text-sm leading-relaxed text-slate-200">
            <input
              name="marketingConsent"
              type="checkbox"
              checked={form.marketingConsent}
              onChange={handleChange}
              className="mt-1 h-4 w-4 shrink-0 accent-cyan-400"
            />
            <span>
              I agree to receive marketing emails from Lion Pride Financial. Consent is optional and is not a condition of receiving services. I may unsubscribe at any time. See our{" "}
              <Link to="/privacy" className="font-medium text-cyan-200 underline hover:text-cyan-100">Privacy Policy</Link>.
            </span>
          </label>
          <div className="rounded-2xl border border-white/10 bg-slate-950/40 p-3">
            <HCaptcha
              sitekey="13e03332-fc3e-4fac-aa46-db4a449a48ba"
              onVerify={(token) => setCaptchaToken(token)}
              ref={captchaRef}
            />
          </div>
          <button type="submit" className="w-full rounded-full bg-cyan-500 py-4 text-lg font-bold text-white shadow-lg shadow-cyan-950/40 transition hover:bg-cyan-400">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
